<div class="header-top">
	<div class="container-fluid">
		<div class="d-inline-block space-right">
			<cfe-language-switch></cfe-language-switch>
		</div>

		<div class="userinfo d-inline-block">
			<ng-container *ngIf="!loggedIn">
				<a href="#" (click)="login()">{{ 'header.button.login' | translate }}</a>
				<a [routerLink]="['/register']" class="register">{{ 'header.button.register' | translate }}</a>
			</ng-container>
			<ng-container *ngIf="loggedIn">
				<span>{{ 'header.text.welcomeUser' | translate }}</span
				>,
				<a [routerLink]="['/user/edit']" *ngIf="editable">{{ name }}</a>
				<span *ngIf="!editable">{{ name }}</span>
				<span class="devider"> | </span>
				<a [routerLink]="['/user-auth/logout']">{{ 'header.button.logout' | translate }}</a>
			</ng-container>
		</div>
	</div>
</div>

<header>
	<div class="container-fluid">
		<div class="ds-header-border"></div>
		<nav class="navbar navbar-expand-lg align-items-end pl-0 pr-0 mt-2 mb-2">
			<div class="row align-items-center">
				<a class="col-auto navbar-brand" [routerLink]="['/']">
					<img src="assets/images/logo.svg" height="50" class="col d-inline-block" alt="Dentsply Sirona Logo" />
				</a>
				<div *ngIf="showHeaderBanner" class="col">
					<div class="row align-items-center">
						<div class="col">
							<div
								[innerHtml]="
									messageKey | translate: { shutdownDate: shutdownDate.toLocaleDateString(currentLanguage, dateOptions) } | keepHtml
								"
							></div>
							<div *ngIf="showImportantMessage" style="color: red; font-weight: bold">
								{{ 'header.text.importantMessage' | translate }}
							</div>
						</div>
						<div *ngIf="showHeaderBannerButton" class="col-auto">
							<cfe-button
								[buttonStyle]="'btn-primary'"
								[iconName]="'forward-arrow'"
								[label]="'header.button.checkDSCoreAvailability' | translate"
								(click)="openLink()"
							></cfe-button>
						</div>
					</div>
				</div>
			</div>
			<button
				class="navbar-toggler"
				(click)="isCollapsed = !isCollapsed"
				type="button"
				[attr.aria-expanded]="!isCollapsed"
				aria-controls="navbarNav"
				aria-label="Toggle navigation"
			>
				<span class="navbar-toggler-icon"></span>
			</button>
		</nav>
		<div class="notice" *ngIf="noticeInfo">
			<h3 *ngIf="noticeHeader">
				<i class="cfe-warning"></i>
				{{ noticeHeader }}
				<i class="cfe-warning"></i>
			</h3>
			<p>{{ noticeInfo }}</p>
		</div>
	</div>
</header>
